export type Template = {
  id: string;
  name: string;
  key: string;
  inspectionType: Template.inspectionType;
  vehicleType: string;
  createdAt: string;
  isActive: boolean;
};

export namespace Template {
  export enum inspectionType {
    VALIDATION_INSPECTION = 'validationInspection',
    VEHICLE_CONDITION = 'vehicleCondition',
  }
}
